import React, { useState } from "react";
import { Button } from "react-bootstrap";

import { useContext } from "../Context";

export default function SetPaymentMethodButton() {
  const { dispatch, actions, state } = useContext();
  const [loading, setLoading] = useState(false);

  const paymentMethodLink = () => {
    setLoading(true);
    actions.paymentMethodLink(dispatch, state.enterpriseId, (data) => {
      document.location.href = data.link;
    });
  };

  return (
    <Button
      className={loading ? "not-possible-click w-200" : "w-200"}
      onClick={paymentMethodLink}
      bsStyle="primary"
    >
      {loading ? "Setup Payment Method ..." : "Setup Payment Method"}
    </Button>
  );
}
